import { backfillUwEntriesRequired } from '@ps20-frontend/migrations';
import {
  CheckoutProduktPreV27,
  CheckoutProduktV27,
  StatePreV27,
  StateV27,
} from './27_migrate_uw_entries_required.interface';

const migrateProdukt = (produkt: CheckoutProduktPreV27): CheckoutProduktV27 => ({
  ...produkt,
  uw: backfillUwEntriesRequired(produkt.uw),
});

export const migrateCheckoutUwEntriesRequired = (
  previousState: StatePreV27,
  newVersion: number,
): StateV27 =>
  ({
    ...previousState,
    version: newVersion,
    produkte: (previousState.produkte ?? []).map(migrateProdukt),
  }) as StateV27;
